import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	title: {
		id: 'projects-directory-v3.page-layout.top-banner.title',
		defaultMessage: 'Your team can start using service projects',
		description: 'Utilize your free Jira Service Management subscription.',
	},
	primaryAction: {
		id: 'projects-directory-v3.page-layout.top-banner.primary-action',
		defaultMessage: 'Create a service project for me',
		description: 'Create my service project',
	},
	secondaryAction: {
		id: 'projects-directory-v3.page-layout.top-banner.secondary-action',
		defaultMessage: 'Dismiss',
		description: 'Dismiss',
	},
	description: {
		id: 'projects-directory-v3.page-layout.top-banner.description',
		defaultMessage:
			'You have Jira Service Management, so your team can triage and streamline incoming requests with dedicated help channels. <l>Learn more about service management in Jira.</l>',
		description:
			'Add 3 team members for free to streamline and triage your incoming requests from other teams with a service desk.',
	},
	errorMessageTitle: {
		id: 'projects-directory-v3.page-layout.top-banner.error-message-title',
		defaultMessage: 'We couldn’t create your service project',
		description: 'Error Message when Project creation failed',
	},
	tryAgainLabel: {
		id: 'projects-directory-v3.page-layout.top-banner.try-again-label',
		defaultMessage: 'Try again',
		description: 'Try Again Label',
	},
	successMessageTitle: {
		id: 'projects-directory-v3.page-layout.top-banner.success-message-title',
		defaultMessage: 'Success!',
		description: 'Success Message Title when Project creation success',
	},
	successMessageDescription: {
		id: 'projects-directory-v3.page-layout.top-banner.success-message-description',
		defaultMessage: 'Your service project has been created for you.',
		description: 'Success Message Description when Project creation success',
	},
	successMessageLink: {
		id: 'projects-directory-v3.page-layout.top-banner.success-message-link',
		defaultMessage: 'Go to your service project',
		description: 'Success Message Link when Project creation success',
	},
});
